import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "string-rule" }

import { reactive, watch } from "vue";

//#region General
type ViewModel = { localModel: string };

export default /*#__PURE__*/_defineComponent({
  __name: 'StringRule',
  props: {
    value: {}
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }) {

const props = __props;



//#endregion

//#region ViewModel
const vm = reactive<ViewModel>({ localModel: props.value });
//#endregion

//#region Update vModel
watch(
  () => vm.localModel,
  (nv) => {
    emits("input", nv);
  }
);
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_b_input = _resolveComponent("b-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_b_input, {
      type: "text",
      modelValue: vm.localModel,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.localModel) = $event)),
      "data-cy": "search-txt"
    }, null, 8, ["modelValue"])
  ]))
}
}

})